function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".meddela-mig_svg__st0{fill:none;stroke:currentColor;stroke-width:.5;stroke-linejoin:round;stroke-miterlimit:10}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "meddela-mig_svg__st0",
  d: "M.2.2h11.4v7.9H.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "meddela-mig_svg__st0",
  d: "M.2.2L6 4.9 11.7.2"
});

function SvgMeddelaMig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "meddela-mig_svg__Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 11.9 8.4",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMeddelaMig;